import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { CartridgesFacade } from '@markant-platform/cartridge/data-access';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthenticatedUserService } from '@markant-platform/shared/user/data-access';

export const serviceManagerGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const cartridgesFacade = inject(CartridgesFacade);
  const authenticatedUserService = inject(AuthenticatedUserService);
  const cartridgeId = route.paramMap.get('cartridgeId');

  if (!cartridgeId) {
    return false;
  }

  const cartridge = await firstValueFrom(cartridgesFacade.cartridgeById$(cartridgeId));

  if (!cartridge) {
    return false;
  }

  return cartridge.serviceManagerId === authenticatedUserService.userId;
};
